import type { IconType } from 'react-icons';
import {
  LuWifi,
  LuAirVent,
  LuBatteryCharging,
  LuShowerHead,
  LuLayers,
  LuBedDouble,
  LuChefHat,
  LuRefrigerator,
  LuMicrowave,
  LuFlame,
  LuCookingPot,
  LuDroplets,
  LuUtensilsCrossed,
  LuUtensils,
  LuTable,
  LuCupSoda,
  LuSandwich,
  LuBlend,
  LuBath,
  LuRows3,
  LuSprayCan,
  LuWind,
  LuWashingMachine,
  LuThermometer,
  LuShirt,
  LuWaves,
  LuTrees,
  LuBeef,
  LuDumbbell,
  LuLaptop,
  LuTv,
  LuDices,
  LuToyBrick,
  LuCar,
  LuCarFront,
  LuPlugZap,
  LuMoveVertical,
  LuArrowUpDown,
  LuUserRound,
  LuUsersRound,
  LuHandPlatter,
  LuSparkles,
  LuClock,
  LuGift,
  LuBriefcaseMedical,
  LuFireExtinguisher,
  LuBellRing,
} from 'react-icons/lu';

/** Icon per amenity name (same icons as the new host UI design). */
const ICONS: Record<string, IconType> = {
  'wi-fi': LuWifi,
  'ac': LuAirVent,
  'power backup': LuBatteryCharging,
  'hot bath water': LuShowerHead,
  'wardrobe(s)': LuLayers,
  'extra linens, pillows': LuBedDouble,
  'kitchen': LuChefHat,
  'fridge': LuRefrigerator,
  'microwave': LuMicrowave,
  'gas stove': LuFlame,
  'induction stove': LuCookingPot,
  'dishwasher': LuDroplets,
  'cooking utensils': LuUtensilsCrossed,
  'basic cutlery': LuUtensils,
  'dining table': LuTable,
  'kettle': LuCupSoda,
  'toaster': LuSandwich,
  'blender': LuBlend,
  'bathtub': LuBath,
  'towels': LuRows3,
  'body wash, hand wash, soap': LuSprayCan,
  'basic toiletries': LuShowerHead,
  'hair dryer': LuWind,
  'washing machine': LuWashingMachine,
  'iron': LuThermometer,
  'laundry service': LuShirt,
  'pvt pool': LuWaves,
  'shared pool': LuWaves,
  'heated pool': LuWaves,
  'jacuzzi': LuBath,
  'pvt garden': LuTrees,
  'shared garden': LuTrees,
  'barbeque grill': LuBeef,
  'gym': LuDumbbell,
  'workspace': LuLaptop,
  'television': LuTv,
  'indoor games': LuDices,
  'kids play area': LuToyBrick,
  'pvt car park': LuCar,
  'shared car park': LuCarFront,
  'ev charging': LuPlugZap,
  'private lift': LuMoveVertical,
  'shared lift': LuArrowUpDown,
  'caretaker': LuUserRound,
  '24/7 caretaker': LuUsersRound,
  'chef on call': LuHandPlatter,
  'house keeping': LuSparkles,
  'flexi checkin/out': LuClock,
  'welcome basket': LuGift,
  'first aid kit': LuBriefcaseMedical,
  'fire extinguisher': LuFireExtinguisher,
  // The backend spells this amenity "Fire Extenguisher".
  'fire extenguisher': LuFireExtinguisher,
  'fire alarm': LuBellRing,
};

/** Lower-case letters and digits only, so spacing, punctuation and non-breaking spaces never break a match. */
const squash = (name: string): string => name.toLowerCase().replace(/[^a-z0-9]/g, '');

const SQUASHED: [string, IconType][] = Object.keys(ICONS).map((key) => [squash(key), ICONS[key]]);

export const getAmenityIcon = (name: string): IconType | undefined => {
  const n = squash(name);
  if (!n) return undefined;
  const exact = SQUASHED.find(([key]) => key === n);
  if (exact) return exact[1];
  // Tolerate small naming differences such as plurals ("Fire Extinguishers") or a suffix.
  const loose = SQUASHED.find(([key]) => n.length >= 5 && (n.startsWith(key) || key.startsWith(n)));
  return loose?.[1];
};
